<template>
  <div>
    <custom-dialog
      :widthDialog="'800px'"
      :classDialog="'create-dialog custome-dialog'"
      :offsetTop="'0px !important'"
      :openDialog="isOpen"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('dialogClosed')"
    >
      <template #body>
        <h3 class="dialogTitle margin-left-0">Đăng ký phòng họp</h3>
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-position="left"
          label-width="160px"
        >
          <el-row :gutter="24">
            <el-col :span="24" class="margin-bottom-15">
              <el-form-item label="Tiêu đề" prop="meetingTitle">
                <el-input
                  v-model="form.meetingTitle"
                  placeholder="Tiêu đề"
                  class="
                    input-border__bottom input-border__radius__0
                    style-fullWidth
                    input-count__bottom
                  "
                  size="medium"
                  maxlength="100"
                  show-word-limit
                  :autosize="{ minRows: 2, maxRows: 5 }"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24" class="margin-bottom-15 margin-top-10">
              <el-form-item label="Nội dung cuộc họp" prop="meetingContent">
                <el-input
                  type="textarea"
                  v-model="form.meetingContent"
                  placeholder="Nội dung cuộc họp"
                  class="
                    input-border__bottom input-border__radius__0
                    style-fullWidth
                    input-count__bottom
                  "
                  size="medium"
                  maxlength="500"
                  show-word-limit
                  :autosize="{ minRows: 2, maxRows: 5 }"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Thời gian bắt đầu" prop="startTime">
                <el-date-picker
                  v-model="form.startTime"
                  size="medium"
                  class="
                    input-border__bottom input-border__radius__0
                    style-fullWidth
                  "
                  type="datetime"
                  placeholder="dd/MM/yyyy HH:mm"
                  format="dd/MM/yyyy HH:mm"
                  :prefix-icon="' '"
                  @change="startTimeChanged"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Thời gian kết thúc" prop="endTime">
                <el-date-picker
                  v-model="form.endTime"
                  size="medium"
                  class="
                    input-border__bottom input-border__radius__0
                    style-fullWidth
                  "
                  type="datetime"
                  placeholder="dd/MM/yyyy HH:mm"
                  format="dd/MM/yyyy HH:mm"
                  :prefix-icon="' '"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :gutter="24" class="">
              <el-form-item prop="sendSMS" label="Gửi SMS">
                <el-checkbox v-model="form.sendSMS"
                  >Gửi nội dung tiêu đề đến điện thoại người dùng</el-checkbox
                >
              </el-form-item>
            </el-col>

            <el-col :gutter="24" class="">
              <el-form-item prop="sendEmail" label="Gửi Email">
                <el-checkbox v-model="form.sendEmail"
                  >Gửi nội dung tiêu đề đến Email người dùng</el-checkbox
                >
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="Phòng họp" prop="meetingRoomId">
                <el-select
                  class="
                    input-border__bottom input-border__radius__0
                    style-fullWidth
                  "
                  v-model="form.meetingRoomId"
                  placeholder="Chọn phòng họp"
                  size="medium"
                  filterable
                  clearable
                  remote
                >
                  <el-option
                    v-for="item in listMeetingRoom"
                    :key="item.id"
                    :label="item.roomName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item
                prop="otherInvolved"
                class="custom-label__input custom-select-people"
              >
                <span class="flex-row flex__left label-input">
                  Thành phần tham dự &nbsp;
                  <el-tooltip
                    content="Cây danh mục nhân viên"
                    placement="top"
                    effect="dark"
                  >
                    <i
                      class="fas fa-cog advance-search color__cyan clickable"
                      @click="isOpenAddPeopleDialog = true"
                    ></i>
                  </el-tooltip>
                </span>
                <el-select
                  class="
                    input-border__bottom input-border__radius__0
                    style-fullWidth
                  "
                  v-model="form.involedUserIds"
                  placeholder="Gõ để bắt đầu tìm kiếm theo email/họ tên/chức danh"
                  size="medium"
                  filterable
                  clearable
                  remote
                  multiple
                  :remote-method="remoteSearchInvoledUsers"
                  :loading="isRemoteSearchInvoledUsers"
                  @change="updateNumberPeople"
                >
                  <el-option
                    v-for="item in displayInvoledUsers()"
                    :key="item.id"
                    :label="getActorLabel(item)"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24" class="margin-bottom-10">
              <el-form-item label="Số lượng tham dự" prop="otherInvolved">
                <el-input
                  type="textarea"
                  v-model="form.otherInvolved"
                  placeholder="Số lượng tham dự"
                  class="
                    input-border__bottom input-border__radius__0
                    style-fullWidth
                    input-count__bottom
                  "
                  size="mini"
                  rows="1"
                  maxlength="500"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Độ quan trọng" prop="criticalLevel">
                <el-select
                  class="
                    input-border__bottom input-border__radius__0
                    style-fullWidth
                  "
                  v-model="form.criticalLevel"
                  placeholder="Độ quan trọng"
                  size="medium"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in criticalLevels"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="Dịch vụ chuẩn bị" prop="services">
                <el-checkbox-group v-model="form.services" class="width__100">
                  <el-checkbox
                    v-for="item in serviceOptions"
                    :key="item.value"
                    :label="item.value"
                    >{{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>

      <template #footer>
        <div class="flex-row form-button__action flex__left">
          <el-button
            :disabled="loading"
            size="medium"
            type="success"
            class="addDocs color__white bg__blue btn-none__border"
            @click="submit"
          >
            <i class="far fa-check-circle font-size__small"></i>
            &nbsp;Gửi yêu cầu
          </el-button>
          <el-button
            type="info"
            size="medium"
            class="btn__cancel btn-none__border"
            @click="$emit('closeDialog')"
            >Bỏ qua
          </el-button>
        </div>
      </template>
    </custom-dialog>
    <dialog-add-people
      :isOpen="isOpenAddPeopleDialog"
      :addedPeopleIds="form.involedUserIds"
      :listUser="involedUsers"
      :selectedUser="selectedHandlersData"
      :listDept="departments"
      v-if="isOpenAddPeopleDialog"
      @closed="isOpenAddPeopleDialog"
      @closeDialog="closeAddPeopleDialog"
      @submit="addInvoledUser"
      :isLoadingPar="isLoading"
    />
  </div>
</template>
<script>
import constants from "../../../constants";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import hanhchinhService from "../../../services/hanhchinhService";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import hcFlowService from "../../../services/hcFlowService";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import utils from "../../../services/utils";
import CustomDialog from "../../common/custom-dialog";
import moment from "moment";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import DialogAddPeople from "./dialog-add-peopleV3.vue";
import meetingRoomService from "../../../services/meetingRoomService";
import departmentService from "../../../services/departmentService";

export default {
  name: "hc-phonghop-create-dialog",
  props: ["isOpen", "id", "flowId", "deptId", "flowCode"],
  mixins: [handleRequestErrorMixin],
  components: {
    CustomDialog,
    DialogAddPeople,
  },

  data() {
    return {
      loading: false,
      criticalLevels: null,
      serviceOptions: null,
      form: {
        meetingTitle: null,
        meetingContent: null,
        startTime: null,
        endTime: null,
        otherInvolved: null,
        criticalLevel: null,
        services: [],
        involedUserIds: null,
        sendSMS: false,
        sendEmail: false,
      },
      rules: {
        meetingTitle: null,
        meetingContent: null,
        startTime: null,
        endTime: null,
        otherInvolved: null,
        criticalLevel: null,
        services: [],
        involedUserIds: null,
      },
      involedUsers: [],
      isLoading: false,
      selectedInvoledUsers: [],
      selectedHandlersData: [],
      departments: [],
      isRemoteSearchInvoledUsers: false,
      hcFlow: null,
      listMeetingRoom: [],
      isOpenAddPeopleDialog: false,
      isEnableAddPeopleDialog: false,
    };
  },

  async created() {
    this.initSelectOptions();
    this.initValidationRules();
    this.initForm();
    this.getListMeetingRoom();
    await this.loadHcFlow();
    await this.loadDataUser("");
    await this.loadDerpartment().then((res) => {
      this.isLoading = false;
    });
  },

  watch: {
    isOpenAddPeopleDialog(newValue) {
      newValue && (this.isEnableAddPeopleDialog = newValue);
    },
    isEnableAddPeopleDialog(newValue) {
      newValue && (this.isOpenAddPeopleDialog = newValue);
    },
  },

  methods: {
    loadDerpartment() {
      this.isLoading = true;
      return departmentService.findAll().then((res) => {
        this.departments = res.data.filter((item) => item.id !== "ROOT");
        let currentDepartment = this.departments.find(
          (x) => x.id === this.$store.getters.userDeptRole.deptId
        );
        if (
          currentDepartment.deptType === constants.DEPARTMENT.DEPT_TYPE.DVTT
        ) {
          this.departments = [
            currentDepartment,
            ...this.departments.filter(
              (x) => x.parentId === currentDepartment.id
            ),
          ];
        } else if (
          !currentDepartment.deptType &&
          currentDepartment.id !== "TCT"
        ) {
          let parentDepartment = this.departments.find(
            (x) => x.id === currentDepartment.parentId
          );
          this.departments = [
            parentDepartment,
            ...this.departments.filter(
              (x) => x.parentId === parentDepartment.id
            ),
          ];
        }
      });
    },
    displayInvoledUsers() {
      let searchedInvoledUsers =
        this.selectedHandlersData && this.selectedHandlersData.length
          ? this.selectedInvoledUsers.filter(
              (x) =>
                this.selectedHandlersData
                  .map((y) => y.data.id)
                  .indexOf(x.id) === -1
            )
          : this.selectedInvoledUsers;
      return [
        ...(this.selectedHandlersData
          ? this.selectedHandlersData.map((item) => item.data)
          : []),
        ...searchedInvoledUsers,
      ];
    },
    getListMeetingRoom() {
      meetingRoomService.getAll().then((res) => {
        this.listMeetingRoom = res.data.listRoom;
      });
    },
    updateNumberPeople() {
      this.selectedHandlersData = this.involedUsers
        .filter((item) => this.form.involedUserIds.indexOf(item.id) !== -1)
        .map((x) => {
          return {
            data: x,
          };
        });
      this.form.otherInvolved = this.form.involedUserIds.length + " người";
    },
    addInvoledUser(data) {
      this.selectedHandlersData = data.userDeptRoleViews;
      this.form.involedUserIds = data.userDeptRoleViews
        .filter((item) => item.data.deptId)
        .map((item) => item.data.id);
      this.updateNumberPeople();
      this.closeAddPeopleDialog();
    },
    closeAddPeopleDialog() {
      this.isOpenAddPeopleDialog = false;
    },
    loadHcFlow() {
      return hcFlowService
        .findById(this.flowId)
        .then((response) => (this.hcFlow = response.data));
    },

    loadDataUser() {
      this.isLoading = true;
      return userDeptRoleViewService
        .findAll()
        .then(
          (response) =>
            (this.involedUsers = (response.data || [])
              .filter(
                (x) =>
                  x.isDefaultRole &&
                  x.status === "active" &&
                  x.usersStatus === "active" &&
                  x.deptStatus === "active"
              )
              .sort((item1, item2) =>
                utils.compareUserDeptRoleView(item1, item2)
              ))
        );
    },

    remoteSearchInvoledUsers(query) {
      this.isRemoteSearchInvoledUsers = true;
      query = (query || "").trim();
      (query
        ? userDeptRoleViewService
            .findAllForHcPhongHopOtherInvoled(query, this.hcFlow.deptId, {
              page: 0,
              size: 100,
              sort: "fullName,asc",
            })
            .then((response) => {
              this.selectedInvoledUsers = (response.data || [])
                .filter(
                  (x) =>
                    x.isDefaultRole &&
                    x.status === "active" &&
                    x.usersStatus === "active" &&
                    x.deptStatus === "active" &&
                    (this.departments &&
                    this.departments.length &&
                    this.$store.getters.userDeptRole.deptId !== "TCT"
                      ? this.departments.map((y) => y.id).indexOf(x.deptId) !==
                        -1
                      : true)
                )
                .sort((item1, item2) =>
                  utils.compareUserDeptRoleView(item1, item2)
                );
            })
        : Promise.resolve()
      ).then(() => {
        if (!query) {
          this.selectedInvoledUsers = [];
        }
        this.isRemoteSearchInvoledUsers = false;
      });
    },

    getActorLabel(userDeptRoleView) {
      return utils.buildUserDeptRoleViewLabel(userDeptRoleView);
    },

    startTimeChanged() {
      this.initEndTime();
    },

    initForm() {
      this.form.criticalLevel =
        constants.HC_CASE_PHONGHOP.CRITICAL_LEVEL.KHONG_LANH_DAO;
      this.form.startTime = new Date();
      this.initEndTime();
    },

    initEndTime() {
      this.form.endTime = this.form.startTime
        ? new moment(this.form.startTime).add(1, "hour").toDate()
        : null;
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur",
      };
      this.rules.meetingTitle = [defaultRequiredConstrains];
      this.rules.meetingContent = [defaultRequiredConstrains];
      this.rules.startTime = [defaultRequiredConstrains];
      this.rules.endTime = [defaultRequiredConstrains];
      this.rules.criticalLevel = [defaultRequiredConstrains];
    },

    initSelectOptions() {
      this.criticalLevels = hanhChinhUtils.buildPhongHopCriticalLevelOptions();
      this.serviceOptions = hanhChinhUtils.buildPhongHopServiceOptions();
    },

    customLabelPriority(option) {
      return option.name;
    },

    convertToSubmitForm() {
      return {
        flowCode: this.flowCode,
        flowId: this.flowId,
        meetingTitle: this.form.meetingTitle,
        meetingContent: this.form.meetingContent,
        startTime: this.form.startTime ? this.form.startTime.getTime() : null,
        endTime: this.form.endTime ? this.form.endTime.getTime() : null,
        otherInvolved: this.form.otherInvolved,
        criticalLevel: this.form.criticalLevel,
        services: this.form.services,
        meetingRoomId: this.form.meetingRoomId,
        meetingRoomName: this.form.meetingRoomId
          ? this.listMeetingRoom.filter(
              (item) => item.id === this.form.meetingRoomId
            )[0].roomName
          : null,
        involedUserIds: this.form.involedUserIds,
        sendSMS: this.form.sendSMS,
        sendEmail: this.form.sendEmail,
      };
    },

    validateForm() {
      return utils.validateFormCommon(this.$refs.form, this.$message);
    },

    validateDateRange() {
      return new Promise((resolve) => {
        let endTime = this.form.endTime;
        let startTime = this.form.startTime;
        if (endTime && startTime && endTime.getTime() < startTime.getTime()) {
          this.$message.error(
            errorMessageFilter({ errorCode: "hcPhongHop.invalidTimeRange" })
          );
          return;
        }
        resolve();
      });
    },

    submit() {
      this.validateForm()
        .then(() => {
          this.validateDateRange();
        })
        .then(() => {
          this.loading = true;
          let submitForm = this.convertToSubmitForm();
          return hanhchinhService
            .RegisterMeetingRoom(submitForm)
            .then(() => {
              this.loading = false;
              this.$message.success(
                errorMessageFilter({
                  errorCode: "hcPhongHop.insertSuccess",
                })
              );
              this.$emit("success");
            })
            .catch((error) => {
              this.loading = false;
              this.commonHandleRequestError(error);
              throw error;
            });
        });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/adminstration/phonghop/PhongHop_Form.vue